import { render, staticRenderFns } from "./AnnounceHistory.vue?vue&type=template&id=90d4c210&scoped=true&"
import script from "./AnnounceHistory.vue?vue&type=script&lang=js&"
export * from "./AnnounceHistory.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceHistory.vue?vue&type=style&index=0&id=90d4c210&prod&lang=css&"
import style1 from "./AnnounceHistory.vue?vue&type=style&index=1&id=90d4c210&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d4c210",
  null
  
)

export default component.exports